import { Box, VisuallyHidden } from '@chakra-ui/react'
import React from 'react'

import {
  CircleBadgeVariant,
  useCircleBadgeStyle,
} from './componentStyles/CircleBadge.style'

interface CircleBadgeProps {
  variant: CircleBadgeVariant
  /** Screen-reader text for the status the color conveys. */
  label?: string
}
export const CircleBadge = ({ variant, label }: CircleBadgeProps) => {
  const style = useCircleBadgeStyle({ variant })
  return (
    <>
      <Box as="span" display="block" css={style} />
      {label && <VisuallyHidden>{label}</VisuallyHidden>}
    </>
  )
}
